<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event.target.value)"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card color="primary" v-if="item.item">
      <AuditToolbar
        :title="`Forklift Audit`"
        :item="item"
        :totalItems="item.totalItems"
        @handlePrevItem="$emit('handlePrevItem', item.index )"
        @handleNextItem="$emit('handleNextItem', item.index )"
        @exit="$emit('input', false)"
      />
      <v-card color="primary" class="elevation-0">
        <v-card-text>
          <h2 class="pa-2 mt-5">Details</h2>
          <v-divider />
          <v-layout row class="mt-3">
            <v-flex>
              <h3 class="pa-2">Forklift Inspected: {{ item.item.lift }}</h3>
              <h3 class="pa-2">Extra remarks: {{ item.item.remarks }}</h3>
            </v-flex>
            <v-flex>
              <h3 class="pa-2">Audit Date: {{ localizeDate(item.item.dateCreated, true) }}</h3>
              <h3 class="pa-2">Audited by: {{ item.item.auditor.name }}</h3>
            </v-flex>
          </v-layout>

          <h2 class="pa-2 mt-5">Motor Off Results</h2>
          <v-divider />

          <v-expansion-panel
            class="primary mt-2"
            v-if="item.item.motorOffMaintenanceLog.length > 0"
          >
            <v-expansion-panel-content class="primary pa-1">
              <template v-slot:actions>
                <v-icon medium color="error">error</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  <h3>
                    MAINTENANCE NEEDED!
                    <v-spacer v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" />
                    <small class="ml-2">(click to expand)</small>
                  </h3>
                </div>
              </template>
              <ul
                class="ma-3"
                v-for="(item, index) in item.item.motorOffMaintenanceLog"
                :key="index"
              >
                <li>{{item}}</li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-layout row class="mt-4 pa-2 primary lighten-3">
            <v-flex xs4>
              <h3>Audit</h3>
            </v-flex>
            <v-flex xs4>
              <h3>Result</h3>
            </v-flex>
            <v-flex xs4>
              <h3>Comment</h3>
            </v-flex>
          </v-layout>
          <v-divider />
          <div v-for="(item, index) in item.item.motorOffQuestionnaire" :key="index+100">
            <v-layout row :class="index % 2 ? 'primary lighten-1 pa-2' : 'pa-2'">
              <v-flex xs4>
                <h4>{{ item.question }}</h4>
              </v-flex>
              <v-flex xs4>
                <h4
                  :style="{ color: item.responses.yes ? 'green' : 'red' }"
                >{{ item.responses.yes ? "PASSED" : "FAILED" }}</h4>
              </v-flex>
              <v-flex xs4>
                <h4>{{ item.responses.comments }}</h4>
              </v-flex>
            </v-layout>
          </div>

          <h2 class="pa-2 mt-5">Motor On Results</h2>
          <v-divider />

          <v-expansion-panel class="primary mt-2" v-if="item.item.motorOnMaintenanceLog.length > 0">
            <v-expansion-panel-content class="primary pa-1">
              <template v-slot:actions>
                <v-icon medium color="error">error</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  <h3>
                    MAINTENANCE NEEDED!
                    <v-spacer v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" />
                    <small class="ml-2">(click to expand)</small>
                  </h3>
                </div>
              </template>
              <ul
                class="ma-3"
                v-for="(item, index) in item.item.motorOnMaintenanceLog"
                :key="index"
              >
                <li>{{item}}</li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-layout row class="mt-4 pa-2 primary lighten-3">
            <v-flex xs4>
              <h3>Audit</h3>
            </v-flex>
            <v-flex xs4>
              <h3>Result</h3>
            </v-flex>
            <v-flex xs4>
              <h3>Comment</h3>
            </v-flex>
          </v-layout>
          <v-divider />
          <div v-for="(item, index) in item.item.motorOnQuestionnaire" :key="index">
            <v-layout row :class="index % 2 ? 'primary lighten-1 pa-2' : 'pa-2'">
              <v-flex xs4>
                <h4>{{ item.question }}</h4>
              </v-flex>
              <v-flex xs4>
                <h4
                  :style="{ color: item.responses.yes ? 'green' : 'red' }"
                >{{ item.responses.yes ? "PASSED" : "FAILED" }}</h4>
              </v-flex>
              <v-flex xs4>
                <h4>{{ item.responses.comments }}</h4>
              </v-flex>
            </v-layout>
          </div>

          <h2 class="mt-4 pa-2">Chatter</h2>
          <v-divider />
          <Chatter v-if="value" reload :id="item.item._id" collection="forklift" color="primary" />
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import AuditToolbar from "../AuditToolbar";
import Chatter from "../../app/chatter";
import Common from "@/mixins/Common";

export default {
  name: "Audit",

  props: ["value", "item"],

  computed: {
    ...mapGetters({
      audits: "audits/getAllAudits"
    })
  },

  components: {
    AuditToolbar,
    Chatter
  },

  watch: {
    value(val) {
      if (!val) {
        let search = this.item.search;
        this.$store.dispatch("audits/getAllAudits", search);
      }
    }
  },

  mixins: [Common]
};
</script>
